import * as types from '../mutation-types'
import store from "../index"
import { v4 as uuidv4 } from 'uuid'

const moduleCarrinho = {
	state: {
		produtos: [],
		qtdProdutos: 0,
	},
	getters: {
		cartProducts: state => { return state.produtos },
		cartLength: state => {
			state.qtdProdutos = 0
			state.produtos.map((item) => { state.qtdProdutos += item.quantidade })
			return Number(state.qtdProdutos.toFixed(2))
		},
	},
	mutations: {
		[types.ADD_ITEM_CART](state, cart) {
			let record

			if (!cart.categorizado && cart.extras.length == 0 && Object.keys(cart.skuSelecionado).length === 0 && !cart.observacao) {
				record = state.produtos.find(p => p.codigo === cart.codigo)
			} else {
				record = state.produtos.find(p => p.uuid === cart.uuid)
			}

			if (cart.operacao == 'ALTER_ITEM_CART' && record) {
				record.quantidade = cart.quantidade
				record.observacao = cart.observacao
				record.extras = cart.extras
				record.valorUnitario = cart.valorUnitario
				record.skuSelecionado = cart.skuSelecionado
				record.imagem = cart.imagem
				record.descricao = cart.descricao
			} else if (record) {
				record.quantidade = record.quantidade + cart.quantidade
			} else {
				state.produtos.push(
					{
						uuid: uuidv4(),
						codigo: cart.codigo,
						descricao: cart.descricao,
						quantidade: cart.quantidade,
						valorUnitario: cart.valorUnitario,
						valorTotal: cart.valorTotal,
						extras: cart.extras,
						imagem: cart.imagem,
						observacao: cart.observacao,
						categorizado: cart.categorizado,
						skuSelecionado: cart.skuSelecionado,
						id: cart.id,
						cadastroProduto: cart.cadastroProduto
					}
				)
			}

			state.produtos.map((item) => {

				if (item.extras) {
					var vlItens = (item.quantidade * item.valorUnitario)
					var vlAdc = 0

					item.extras.map((extra) => {
						if (extra.quantidade > 0 || extra.cobrar) {
							if (extra.quantidade == 0 && extra.cobrar)
								extra.quantidade = extra.quantidadeFixa > 0 ? extra.quantidadeFixa : 1
							vlAdc += ((extra.preco * extra.quantidade) * item.quantidade)
						}
					})
					item.valorAdicional = vlAdc
					item.valorTotal = vlItens + vlAdc
				} else {
					item.valorTotal = (item.quantidade * item.valorUnitario)
					item.valorAdicional = 0
				}
			})
		},
		[types.DEL_ITEM_CART](state, cart) {
			state.produtos = state.produtos.filter(p => p.uuid != cart.uuid)
		},
		[types.ADD_CART](state, cart) {
			state.produtos = cart
		},
		[types.SAVE_LOCAL_CART](state) {
			localStorage.setItem('__cart' + store.getters.catalogo.identificadorCatalogo, JSON.stringify({
				identificadorCatalogo: store.getters.catalogo.identificadorCatalogo,
				idPedido: store.getters.idPedido,
				produtos: state.produtos
			}))
		},
		[types.DELETE_LOCAL_CART](state) {
			state.produtos = []
		},
	},
	actions: {
		addToCart({ commit }, cart) {
			commit(types.ADD_ITEM_CART, cart)
			if (!cart.cadastroProduto.categorizado && (!cart.cadastroProduto.extras || cart.cadastroProduto.extras.length == 0)) commit(types.SAVE_LOCAL_CART)
		},
		saveCart({ commit }) {
			commit(types.SAVE_LOCAL_CART)
		},
		delToCart({ commit }, cart) {
			commit(types.DEL_ITEM_CART, cart)
			commit(types.SAVE_LOCAL_CART)
		},
		loadLocalCart({ commit }, cart) {
			commit(types.ADD_CART, cart)
		},
		deleteLocalCart({ commit }) {
			commit(types.DELETE_LOCAL_CART)
			commit(types.SAVE_LOCAL_CART)
		}
	}
}

export default moduleCarrinho